import { render, staticRenderFns } from "./jgbIndex.vue?vue&type=template&id=0e8665aa&scoped=true"
import script from "./jgbIndex.vue?vue&type=script&lang=js"
export * from "./jgbIndex.vue?vue&type=script&lang=js"
import style0 from "./jgbIndex.vue?vue&type=style&index=0&id=0e8665aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8665aa",
  null
  
)

export default component.exports